import { useQuery } from '@tanstack/react-query';

import { TypesenseCollection } from '../types';
import { getEmployeeSelectOptionById } from './employees';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const EMPLOYEE_OPTION_KEY = 'employeeOption';

export const useGetEmployeeOptionById = (id: number | string | undefined) => {
  const _id = id && typeof id === 'string' ? id : (id?.toString() ?? undefined);

  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.EMPLOYEES_VIEW.keyName]?.key ?? null; // use _VIEW key here, if a user has no view access, it also has no higher access

  const { data, ...restProps } = useQuery({
    queryKey: [EMPLOYEE_OPTION_KEY, _id, collectionApiKey],
    queryFn: () => getEmployeeSelectOptionById(_id!, collectionApiKey!),
    enabled: !!_id && !!collectionApiKey,
  });

  return { data, ...restProps };
};
